import { useCallback } from 'react';
import { SiteContext } from '../SiteContext';
import useContext from './useContext';

export default (prefix?: string) => {
  const {
    data: { cdnUrl },
  } = useContext(SiteContext);

  return useCallback((path: string) => `${cdnUrl}${prefix}${path}`, [prefix, cdnUrl]);
};
